import * as React from 'react';

function SettingsIcon({ color = '#545454', ...props }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 24 24' fill='none' {...props}>
			<path
				d='M20 7h-9m3 10H5m9 0a3 3 0 106 0 3 3 0 00-6 0zM10 7a3 3 0 11-6 0 3 3 0 016 0z'
				stroke={color}
				strokeWidth={2}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default SettingsIcon;
